import type { ScopeConfig } from './types';
import { ShipmentScope } from './types';

export const scopeConfigs: ScopeConfig[] = [
  { kpiField: 'all', label: 'All', scope: ShipmentScope.ALL },
  { kpiField: null, label: 'High priority', scope: ShipmentScope.HIGH_PRIORITY },
  { kpiField: 'collection', label: 'Collection', scope: ShipmentScope.COLLECTION },
  { kpiField: 'inTransit', label: 'In transit', scope: ShipmentScope.IN_TRANSIT },
  { kpiField: 'delivery', label: 'Delivery', scope: ShipmentScope.DELIVERY },
  { kpiField: 'recentlyDelivered', label: 'Recently delivered', scope: ShipmentScope.RECENTLY_DELIVERED }
];
